import {
  handFor, scaleFor, deadScaleFor,
  TOKEN_H, CORPSE_REL,
} from '../spriteLayout';
import type { Fighter, Scene } from './types';

export const spriteOf = (sc: Scene, f: Fighter) =>
  sc.bodies[`${f.skin}_${f.stance}`]
  ?? sc.bodies[`${f.skin}_rifle`]
  ?? Object.values(sc.bodies)[0];
export const corpseOf = (sc: Scene, f: Fighter) =>
  sc.bodies[`${f.skin}_dead`] ?? spriteOf(sc, f);
export const weaponOf = (sc: Scene, f: Fighter) =>
  (f.weaponSkin ? sc.weaponSkins[f.weaponSkin] : undefined) ?? sc.weapons[f.weaponKey] ?? Object.values(sc.weapons)[0];

export const scaleOf = (sc: Scene, f: Fighter) =>
  (TOKEN_H * scaleFor(f.skin)) / spriteOf(sc, f).bh;
export const corpseScaleOf = (sc: Scene, f: Fighter) => {
  const cp = corpseOf(sc, f);
  return (TOKEN_H * CORPSE_REL * scaleFor(f.skin) * deadScaleFor(f.skin)) / Math.max(cp.bw, cp.bh);
};
export const handLocal = (sc: Scene, f: Fighter) => {
  const sp = spriteOf(sc, f);
  const s = scaleOf(sc, f);
  const hand = handFor(f.skin, f.stance);
  const dx = (sp.bx + sp.bw * hand.x - (sp.bx + sp.bw / 2)) * s * f.dir;
  const dy = (sp.by + sp.bh * hand.y - (sp.by + sp.bh)) * s;
  return { dx, dy, s };
};
export const handOf = (sc: Scene, f: Fighter) => {
  const { dx, dy, s } = handLocal(sc, f);
  return { x: f.x + dx, y: f.y + dy, s };
};
